import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#202020"
        fillOpacity='0.5'
        d="M14 2a.667.667 0 01.667.667v4.666h-1.333v-4H2.667v9.334h4V14H2.001a.666.666 0 01-.667-.667V2.667A.667.667 0 012.001 2h12zm0 6.667a.667.667 0 01.667.666v4a.667.667 0 01-.666.667H8.667a.666.666 0 01-.666-.667v-4a.667.667 0 01.666-.666h5.334zM13.335 10h-4v2.667h4V10zM4.472 4.195l1.5 1.5 1.362-1.362V8H3.667L5.03 6.638l-1.5-1.5.943-.943z"
      ></path>
    </svg>
  )
}

export default Icon
